import * as z from "zod";

export const StringOrArrayBuffer = z.custom<ArrayBuffer>({
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  validate: (data: never) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (!(data instanceof ArrayBuffer)) {
      return { message: "Value is not an ArrayBuffer" };
    }

    return null;
  },
});
